<button mat-button matTooltip="refresh" color="primary" class="refresh-button" (click)="refresh()">
  <mat-icon>refresh</mat-icon>
</button>

@if (!loading && !error) {
  <div class="example-element-detail">
    <div class="example-element-description">
      @if (conditional.grouped) {
        <div>
          @for (column of conditional.detailsConfig.columns; track column; let i = $index) {
            <div>
              @if (!isIgnored(column, readData(column))) {
                <app-entity-group-subset
                  [data]="readData(column)"
                  [config]="column"
                  [formGroup]="formGroup"
                  [edit]="false"
                  [column]="i"
                  [row]="0"
                  [mode]="'view'">
                </app-entity-group-subset>
              }
            </div>
          }
        </div>
      }
      @if (!conditional.grouped) {
        <div>
          @for (field of getDisplayableFields(); track field) {
            <div class="label-container">
              <div class="label-info">
                @if (!field.noLabel) {
                  <div>{{ field.label }}:</div>
                }
                @if (field.help) {
                  <button class="tooltip-button" [matTooltip]="field.help">
                    <mat-icon class="info">help</mat-icon>
                  </button>
                }
              </div>
              @if (data[field.name]) {
                <app-form-field
                  class="form-container"
                  [editMode]="false"
                  [type]="field.type"
                  [data]="data[field.name]"
                  [fieldConfig]="field"
                  [formGroup]="formGroup"></app-form-field>
              }
              @if (!data[field.name]) {
                <div class="display-inline">-</div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
@if (error && !loading) {
  <div class="expanded-row-error">
    <span><i class="far fa-frown"></i></span>
    <span>{{ error }}</span>
  </div>
}
@if (loading && !error) {
  <mat-spinner class="spinner-container" [diameter]="24"></mat-spinner>
}
